export default {
    //search-company
    people: "लोग",
    clearAll: "सभी साफ़ करें",
    searchProspects: "खोजें...",
    //actions
    isFoundIn: "में पाया गया",
    isNotFoundWithinAnyLists: "किसी भी सूची में नहीं मिला",
    l: " सूचियाँ",
    remove: "हटाएँ",
    saveToLists: "सूचियों में सहेजें",
    DeleteFailed: "हटाना विफल",
    //delete dialog
    areYouSureYouWantToDeleteThisRecord:
      "क्या आप वाकई इस रिकॉर्ड को हटाना चाहते हैं?",
    proceedingWithDeletionWillResultInPermanentRemovalOfTheList:
      "हटाने की प्रक्रिया जारी रखने से सूची स्थायी रूप से हट जाएगी",
    byCancelingYouEnsureThatNoListsWillBeRemoved:
      "रद्द करके, आप यह सुनिश्चित करते हैं कि कोई भी सूची हटाई नहीं जाएगी",
    //export dialog
    holdOnWereGeneratingYourExport: "रुकिए, हम आपका निर्यात बना रहे हैं",
    UseThisButtonOnlyIfYouWishToCancelYourAction:
      "इस बटन का उपयोग तभी करें जब आप अपनी कार्रवाई रद्द करना चाहते हों",
    //save search pop
    saveSearch: "खोज सहेजें",
    newSaveSearch: "नई खोज सहेजें",
    UpdateSavedSearch: "सहेजी गई खोज अपडेट करें",
    enterNewSearchName: "नई खोज का नाम दर्ज करें",
    visibility: "दृश्यता",
    manageWhoCanSeeYourSavedSearch: "प्रबंधित करें कि कौन आपकी सहेजी गई खोज देख सकता है",
    private: "निजी",
    onlyYouCanSeeYourSavedSearch: "केवल आप ही अपनी सहेजी गई खोज देख सकते हैं",
    everyoneCanSeeYourSavedSearch: "हर कोई आपकी सहेजी गई खोज देख सकता है",
    pinSavedSearch: "सहेजी गई खोज पिन करें",
    findSavedSearch: "सहेजी गई खोज ढूंढें",
    enterSavedSearchName: "सहेजी गई खोज का नाम दर्ज करें",
    duplicate: "डुप्लिकेट",
    update: "अपडेट",
    enterATitleForYourCard: "अपने कार्ड के लिए एक शीर्षक दर्ज करें",
    enterYourCardNumber: "अपना कार्ड नंबर दर्ज करें",
    digit: "3-अंकीय",
    provideYourCompleteAddress: "अपना पूरा पता प्रदान करें",
    selectYourCountry: "अपना देश चुनें",
    //add credits pop
    ClickTheButtonBelowToAddMoreCredits:
      "और क्रेडिट जोड़ने के लिए नीचे दिए गए बटन पर क्लिक करें!",
    PleaseEnterTheAmountYouLikeToTopUpToYourCredit:
      "कृपया वह राशि दर्ज करें जिसे आप अपने क्रेडिट में टॉप-अप करना चाहते हैं",
    //companyLink\contactBtn\functionBtn\default
    more: "अधिक",
    verified: "सत्यापित",
    GetEmailSuccessfully: "ईमेल सफलतापूर्वक प्राप्त हुआ",
    CopySuccessfully: "सफलतापूर्वक कॉपी किया गया",
    recorded: "रिकॉर्ड किया गया",
    implement: "लागू करें",
    sequence: "अनुक्रम",
    of: "का",
    toAssistYouEffectivelyWeRequireFurtherDetailsAbout:
      "आपकी प्रभावी ढंग से सहायता करने के लिए, हमें आपकी खोज प्राथमिकताओं के बारे में अधिक विवरण की आवश्यकता है। कृपया अपने इच्छित मानदंडों को निर्दिष्ट करने के लिए बाईं ओर के पैनल में फ़िल्टर विकल्पों का उपयोग करें, जिससे हम खोज परिणामों को परिष्कृत कर सकें और आपको लक्षित व्यक्ति प्रदान कर सकें जो आपकी आवश्यकताओं को पूरा करते हैं।",
  
    //filter
    all: "सभी",
    my: "मेरा",
    team: "टीम",
    lists: "सहेजी गई सूचियाँ",
    employees: "कर्मचारी",
    technologies: "प्रौद्योगिकियाँ",
    socialmedia: "सोशल मीडिया",
    enterSocialMedia: "सोशल मीडिया दर्ज करें",
    noResultsFound: "कोई परिणाम नहीं मिला",
    searchCompanies: "कंपनियां खोजें",
    filters: "फ़िल्टर",
    enterCompanies: "कंपनियां दर्ज करें",
    accountHqLocation: "खाता मुख्यालय स्थान",
    CityStateCountryZIP: "शहर/राज्य/देश/ज़िप",
    enterLocations: "स्थान दर्ज करें",
    revenue: "राजस्व",
    chooseARangeOfRevenue: "राजस्व की एक सीमा चुनें",
    ofRevenueIsUnknown: "का राजस्व अज्ञात है",
    technology: "प्रौद्योगिकी",
    category: "श्रेणी",
    categories: "श्रेणियां",
    enterCategories: "श्रेणियां दर्ज करें",
    enterTechnologies: "प्रौद्योगिकियां दर्ज करें",
    enterIndustries: "उद्योग दर्ज करें",
    employee: "कर्मचारी",
    predefinedRange: "पूर्व-परिभाषित सीमा",
    ofEmployeesIsUnknown: "के कर्मचारी अज्ञात हैं",
    enterNames: "नाम दर्ज करें",
    jobTitle: "नौकरी का शीर्षक",
    searchForAJobTitle: "नौकरी का शीर्षक खोजें",
    founded: "स्थापित",
    chooseARangeOfFoundedTime: "स्थापित होने की समय सीमा चुनें",
    from: "से",
    to: "तक",
    specialties: "विशेषज्ञताएं",
    enterSpecialties: "विशेषज्ञताएं दर्ज करें",
    location: "स्थान",
    excludedLocationsLabel: 'स्थान [बहिष्कृत]',
    location_exclude: "[बहिष्कृत]",
    total: "कुल",
    department: "विभाग",
    EnterDepartments: "विभाग दर्ज करें",
    JobTitle: "नौकरी का शीर्षक",
    EnterJobTitles: "नौकरी के शीर्षक दर्ज करें",
    ManagementLevel: "प्रबंधन स्तर",
    EnterManagementLevels: "प्रबंधन स्तर दर्ज करें",
    AccountHQ: "खाता मुख्यालय",
    ContactHQ: "संपर्क मुख्यालय",
    departmentFunction: "विभाग का कार्य",
    EnterJobFunctions: "नौकरी के कार्य दर्ज करें",
    enterNamesAndPressTheEnterKey: "नाम दर्ज करें और एंटर कुंजी दबाएं...",
    EnterJobTitlesAndPressTheEnterLKey:
      "शीर्षक दर्ज करें और एंटर कुंजी दबाएं...",
    contactDetails: "संपर्क विवरण",
    filterMustContain: "इसमें होना चाहिए",
    filterWorkEmail: "कार्य ईमेल",
    filterPersonalEmail: "व्यक्तिगत ईमेल",
    filterPhone: "फ़ोन नंबर",
    filterHasEmail: "ईमेल उपलब्ध है",
    filterHasPhone: "फ़ोन नंबर उपलब्ध है",
    filterExcludeWithoutContact: "संपर्क विवरण रहित संपर्कों को बहिष्कृत करें",
    pleaseSelectRange: "कृपया एक सीमा चुनें",
    exclude_locations: "स्थान बहिष्कृत करें",
    filterExclude: "बहिष्कृत करें",
  
    //table
    selectAllCompanies: "सभी कंपनियां चुनें",
    selected: "चयनित",
    export: "निर्यात करें",
    industry: "उद्योग",
    keywords: "कीवर्ड",
    companyLocation: "कंपनी का स्थान",
    action: "कार्रवाई",
    contact: "संपर्क",
    Title: "शीर्षक",
    clearSelection: "चयन साफ़ करें",
    selectNumberOfCompanies: "कंपनियों की संख्या चुनें",
    maxCompanies: "अधिकतम कंपनियां",
    youCanOnlySelectAMaximumOf25Companies:
      "आप अधिकतम 25 कंपनियों का ही चयन कर सकते हैं।",
    UpgradeYourPlanNow: "अभी अपनी योजना अपग्रेड करें!",
    viewPlans: "योजनाएं देखें",
    applySelection: "चयन लागू करें",
    selectNumberOfProspects: "संभावित ग्राहकों की संख्या चुनें",
    maxProspects: "अधिकतम संभावित ग्राहक",
    maxProspectsPerCompany: "प्रति कंपनी अधिकतम संभावित ग्राहक",
    youCanOnlySelectAMaximumOf25Prospects:
      "आप अधिकतम 25 संभावित ग्राहकों का ही चयन कर सकते हैं।",
    PleaseSelectTheDataToBeExported: "कृपया निर्यात किए जाने वाले डेटा का चयन करें",
    overview: "अवलोकन",
    genericContacts: "सामान्य संपर्क",
    size: "आकार",
    contactLocation: "संपर्क स्थान",
    pleaseSelectItems: "कृपया आइटम चुनें",
    specialties: "विशेषज्ञताएं",
    moreSpecialty: "+{count} और",


    // 新UI
    prospectsSearch: "संभावित ग्राहक खोज",
    companiesSearch: "कंपनियां खोज",
    savedSearches: "सहेजी गई खोजें",
    savedLists: "सहेजी गई सूचियाँ",


    // saved list and saved searches
    sortAndFilter: "क्रमबद्ध और फ़िल्टर करें",
    sortBy: "इसके अनुसार क्रमबद्ध करें",
    filterAll: 'सभी',
    filterPrivate: 'निजी',
    filterTeam: 'टीम',
    searchSavedLists: "सहेजी गई सूचियाँ खोजें",
    savedSearchName: "सहेजी गई खोज का नाम",
    noFilteringOptionsAvailable: "कोई फ़िल्टरिंग विकल्प उपलब्ध नहीं हैं।",
    manageWhoCanSeeThisSearch: "प्रबंधित करें कि कौन इस खोज को देख सकता है",
    noSavedSearchesMatchYourQuery: "आपकी क्वेरी से मेल खाने वाली कोई सहेजी गई खोज नहीं है। अलग-अलग कीवर्ड आज़माएं या अपनी वर्तनी जांचें।",
    onlyU: "केवल आप",
    anyoneOnTheTeam: "टीम में कोई भी",
    createNewList: "नई सूची बनाएं",
    groupTeam: "टीम",
    groupPersonal: "व्यक्तिगत",
    manageWhoCanViewThisList: "प्रबंधित करें कि कौन इस सूची को देख सकता है",
    enterAListName: "एक सूची का नाम दर्ज करें",
    savedList: "सहेजी गई सूची",
    listName: "सूची का नाम",
    saveContactsTo: "संपर्क को इसमें सहेजें",
    contactEmails: "संपर्क ईमेल",
    contactPhones: 'संपर्क फ़ोन नंबर',
    unlockContactDetails: "संपर्क विवरण अनलॉक करें",
    getContactInfo: 'संपर्क जानकारी प्राप्त करें',
    contactDetailsAreOnTheWay: "संपर्क विवरण रास्ते में हैं",
    noDataAvailable: 'कोई डेटा उपलब्ध नहीं है',
    accessEmails: "ईमेल एक्सेस करें",
    accessPhoneNumber: "फ़ोन नंबर एक्सेस करें",
    accessPhoneNumbersAndEmails: "फ़ोन नंबर और ईमेल एक्सेस करें",

    redemptionComplete: "मोचन पूरा!",
    bulkRedeemProcessing: "बल्क रिडीम प्रोसेसिंग...",
    notifyMeWhenCompleted: "पूरा होने पर मुझे सूचित करें",
    expectedTime: "अनुमानित समय:",
    redeemSeconds: "{count} सेकंड",
    redeemLoading: "लोड हो रहा है...",
    estimatedCharge: "अनुमानित शुल्क: {count} क्रेडिट",


    estimatedCost: "अनुमानित लागत: {count} क्रेडिट",
    finalChargeBasedOnRequest: "अनुरोध के सफल समापन के आधार पर अंतिम शुल्क भिन्न हो सकता है",
    showLess: "कम दिखाएं",
    exportLeadsToCSV: "लीड्स को CSV में निर्यात करें",
    exportComplete: "निर्यात पूरा हुआ!",
    exporting: "निर्यात हो रहा है...",
    pleaseSelectTheFieldsThatNeedToBeExported: "कृपया उन फ़ील्ड का चयन करें जिन्हें निर्यात करने की आवश्यकता है",
    exportLeads: "आप {count} लीड का निर्यात करने वाले हैं। आपकी चयन के आकार के आधार पर इसमें कुछ क्षण लग सकते हैं। | आप {count} लीड्स का निर्यात करने वाले हैं। आपकी चयन के आकार के आधार पर इसमें कुछ क्षण लग सकते हैं।",
    dataFieldsToInclude: "शामिल किए जाने वाले डेटा फ़ील्ड",
    savedListRecords: '{count} रिकॉर्ड',
    deleteList: "सूची हटाएं",
    actionCannotBeUndone: "क्या आप वाकई इस सूची को हटाना चाहते हैं? यह कार्रवाई पूर्ववत नहीं की जा सकती।",
    selectedContactsNumber: "चयनित संपर्कों में से {count}",
    btnSave: "सहेजें",
    btnUnsave: "सहेजना बंद करें",
    specialties: "विशेषज्ञताएं",
    upgradeNowToAccessMore: "अधिक एक्सेस करने के लिए अभी अपग्रेड करें!",
    selectCompanyNumber: "अपनी वर्तमान योजना के साथ अधिकतम {count} कंपनी चुनें। | अपनी वर्तमान योजना के साथ अधिकतम {count} कंपनियां चुनें।",
    selectPeopleNumber: "अपनी वर्तमान योजना के साथ अधिकतम {count} संभावित ग्राहक चुनें। | अपनी वर्तमान योजना के साथ अधिकतम {count} संभावित ग्राहक चुनें।",
    selectAll: "सभी",
    selectThisPage: 'यह पृष्ठ',
    selectCustomize: 'अनुकूलित करें',
    pleaseSelectTheFilteringType: "कृपया फ़िल्टरिंग प्रकार चुनें",
    theQuantityCannotBeZero: 'मात्रा 0 नहीं हो सकती',
    filterSearch: "फ़िल्टर खोज",
    view: "देखें",
    deleteSavedSearch: "सहेजी गई खोज हटाएं",
    deleteThisSavedSearch: "क्या आप वाकई इस सहेजी गई खोज को हटाना चाहते हैं? यह कार्रवाई पूर्ववत नहीं की जा सकती।",
    createASequenceToStartAutomatingYourOutreach: "अपने आउटरीच को स्वचालित करना शुरू करने के लिए एक अनुक्रम बनाएं और जब आप तैयार हों तो यहां आइटम जोड़ें।",
    unsaveThemFromHere: "यदि चुने गए संभावित ग्राहक पहले से सहेजे गए हैं, तो आप उन्हें यहाँ से हटा सकते हैं।",
    createAListToSaveAndOrganizeProspects: "अपने संभावित ग्राहकों को सहेजने और व्यवस्थित करने के लिए एक सूची बनाएं",
    savedFilters: "बचाए गए फ़िल्टर",
    viewResults: "परिणाम देखें",

    // search empty
    resultNoResultsFound: "कोई परिणाम नहीं मिला",
    noContactsThatMatchYourSearch: "आपकी खोज या फ़िल्टर से कोई मेल नहीं खाता। <br />फ़िल्टर बदलने या अलग-अलग कीवर्ड का उपयोग करने का प्रयास करें।",
    requestTimedOut: "अनुरोध का समय समाप्त हो गया",
    theServerIsCurrentlyBusy: "सर्वर वर्तमान में व्यस्त है, और हम <br />परिणाम लोड नहीं कर सके। कृपया पृष्ठ को रीफ़्रेश करने का प्रयास करें।",
    btnRefresh: "रीफ़्रेश करें",

    // tooltip
    tooltipRedeemEmail: "ईमेल रिडीम करें",
    tooltipRedeemPhone: "फ़ोन रिडीम करें",
    tooltipRedeemEmailAndPhone: "सभी रिडीम करें",
    tooltipSearchPeople: "चयनित कंपनियों से लोगों को ढूंढें",
    tooltipFilter: "फ़िल्टर",
    tooltipSequence: "वर्कफ़्लो",
    tooltipSave: "सूची में सहेजें",
    textFindPeople: "लोगों को ढूँढें",

    // recent mode
    recentMode: "हाल का मोड",
    tryRealTimeAgain: "रीयल-टाइम फिर से कोशिश करें",
    realTimeResultsAreTemporarilyPaused: 'एपीआई सीमाओं के कारण रीयल-टाइम परिणाम अस्थायी रूप से रोक दिए गए हैं',
    

    // company-detail
    companies: "कंपनियां",

    // recent search
    popularUseCases: "लोकप्रिय उपयोग के मामले",
    skipTheGuesswork: "अंदाज़ा लगाना छोड़ें — लोकप्रिय फ़िल्टर संयोजनों के साथ शुरू करें।",
    labelRecentSearches: "हाल की खोजें",
    labelRecentSavedFilters: "हाल ही में सहेजे गए फ़िल्टर",
    useThisFilterSetup: "इस फ़िल्टर सेटअप का उपयोग करें",
    startByApplyingFilters: "बाएं पैनल से फ़िल्टर लागू करके प्रासंगिक संपर्क और कंपनियों को खोजना शुरू करें।",



    // 
    k: 'k',

  filterAdvertisementStartDateSubTitle: "विज्ञापन प्रारंभ तिथि अवधि",
  filterAdvertisementEndDateSubTitle: "विज्ञापन समाप्ति तिथि अवधि",
  filterAdvertisementSearchTermsSubTitle: "विज्ञापन खोज शब्द",
  filterAdvertisementExcludeTargetLocation: "लक्षित स्थान को बाहर रखें",
  active_filters_count: "1 सक्रिय फ़िल्टर | {count} सक्रिय फ़िल्टर",
  company_list: "कंपनी सूचियाँ",
  filter_presets: "फ़िल्टर प्रीसेट",
  my_list: "मेरी सूची",
  company_profile: "कंपनी प्रोफ़ाइल",
  people_workforce: "लोग एवं कार्यबल",
  technology_presence: "प्रौद्योगिकी और उपस्थिति",
  saved_searches_count: "{count} सहेजे गए",
  filterJobExcludeLocation: "बहिष्कृत जॉब स्थान",

  enter_keywords: "कीवर्ड दर्ज करें",
  filter_keywords_description_search_title: "विवरण में खोजें",
  filter_keywords_description_search_tooltip: "कंपनी विवरण में कीवर्ड खोजें।",
  filter_places_description_search_title: "विशिष्ट स्थान बाहर करें",
  filter_places_description_search_tooltip: "अपने खोज परिणामों से विशिष्ट स्थान बाहर करें।",
  enter_places: "स्थान दर्ज करें",
  enterAdvertisementSearchTerms: "खोज शब्द दर्ज करें और एंटर कुंजी दबाएं...",
  people_list: "लोगों की सूची",
  clear: "साफ़ करें",
  places: "स्थान",

  expand_filters: "फ़िल्टर खोलें",
  collapse_filters: "फ़िल्टर बंद करें",
};
